(function () {
  var SECTION_SELECTOR = '.oddit-footer-main';
  var sectionState = new Map();

  function initMarquee(section) {
    var marquee = section.querySelector('[data-marquee]');
    var track = section.querySelector('[data-marquee-track]');
    var firstSet = track ? track.querySelector('[data-marquee-set]') : null;
    if (!marquee || !track || !firstSet) return null;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function enable() {
      track.style.animationPlayState = 'running';
    }

    function disable() {
      track.style.animationPlayState = 'paused';
    }

    function ensureCoverage() {
      // Measure the canonical set width — including padding-right — so the keyframe
      // can translate by an exact integer number of pixels and loop seamlessly.
      var setWidth = firstSet.getBoundingClientRect().width;
      if (!setWidth) return;

      var marqueeWidth = marquee.getBoundingClientRect().width;
      // We need the track to contain at least 1 set width MORE than the viewport
      // so that during a full -setWidth translation, the visible area is always filled.
      var minSets = Math.ceil(marqueeWidth / setWidth) + 1;

      var currentSets = track.children.length;
      var template = firstSet;
      while (track.children.length < minSets) {
        var clone = template.cloneNode(true);
        clone.removeAttribute('data-marquee-set');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }

      track.style.setProperty('--marquee-set-width', setWidth + 'px');
      track.setAttribute('data-marquee-ready', 'true');
    }

    // Run after layout so set width is accurate. Re-run after fonts load (text widths
    // can shift), and on resize.
    ensureCoverage();
    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(ensureCoverage);
    }
    var resizeHandler = function () { ensureCoverage(); };
    window.addEventListener('resize', resizeHandler);

    if (reducedMotion.matches) {
      disable();
    } else {
      enable();
    }

    function handleMotionChange(e) {
      e.matches ? disable() : enable();
    }

    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', handleMotionChange);
    } else if (reducedMotion.addListener) {
      reducedMotion.addListener(handleMotionChange);
    }

    function handleVisibilityChange() {
      if (reducedMotion.matches) return;
      track.style.animationPlayState = document.hidden ? 'paused' : 'running';
    }
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return {
      reducedMotion: reducedMotion,
      handleMotionChange: handleMotionChange,
      handleVisibilityChange: handleVisibilityChange,
      resizeHandler: resizeHandler
    };
  }

  function destroyMarquee(state) {
    if (!state) return;
    if (state.reducedMotion && state.handleMotionChange) {
      if (state.reducedMotion.removeEventListener) {
        state.reducedMotion.removeEventListener('change', state.handleMotionChange);
      } else if (state.reducedMotion.removeListener) {
        state.reducedMotion.removeListener(state.handleMotionChange);
      }
    }
    if (state.handleVisibilityChange) {
      document.removeEventListener('visibilitychange', state.handleVisibilityChange);
    }
    if (state.resizeHandler) {
      window.removeEventListener('resize', state.resizeHandler);
    }
  }

  function initSection(section) {
    if (!section) return;
    if (sectionState.has(section)) return;
    var state = { marquee: initMarquee(section) };
    sectionState.set(section, state);
  }

  function destroySection(section) {
    var state = sectionState.get(section);
    if (!state) return;
    destroyMarquee(state.marquee);
    sectionState.delete(section);
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.matches && e.target.matches(SECTION_SELECTOR)
      ? e.target
      : e.target.querySelector && e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.matches && e.target.matches(SECTION_SELECTOR)
      ? e.target
      : e.target.querySelector && e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();